import { FilterPosParams } from '@features/backOffice/report/posDeviceSale/type';
import {
  BranchReportParams,
  CreditSaleParams,
  DailyReportMostSailedParams,
  DailyReportParams,
  HourlyReportMostSailedParams,
  HourlyReportParams,
  ItemsReportParams,
  ItemsReportParamsPerHour,
  ItemsTableReport,
  MenuItemReportParams,
  OrderstatisticsExcelParams,
  SaleDetailsParams,
  SnappfoodReportParams,
  SummeryReportParams,
} from '@models/payload/report';
import { ropoloRequest } from '@services/axios';
import { OrderItemsDeliveryReportExcelParams, OrderItemsSalesParams } from './type';

const getDailyInfoReports = async (params: DailyReportParams) =>
  (
    await ropoloRequest.reportsOrderstatisticsList(params, {
      paramsSerializer: {
        indexes: null,
      },
    })
  ).data;

const getDailyMostSailedReports = async (params: DailyReportMostSailedParams) =>
  (
    await ropoloRequest.reportsMostsailedList(params, {
      paramsSerializer: {
        indexes: null,
      },
    })
  ).data;

const getDailyMostToppingSailedReports = async (params: DailyReportMostSailedParams) =>
  (await ropoloRequest.reportsMostsaileditemtoppingList(params)).data;

const downloadDailyExcelReports = async (params: DailyReportMostSailedParams) =>
  (
    await ropoloRequest.reportsMostsailedExcelList(params, {
      paramsSerializer: {
        indexes: null,
      },
    })
  ).data;

const getHourlyInfoReportsService = async (params: HourlyReportParams) =>
  (
    await ropoloRequest.reportsOrderstatisticsperhourList(params, {
      paramsSerializer: {
        indexes: null,
      },
    })
  ).data;

const getHourlyInfoReportsFromToService = async (params: HourlyReportParams) =>
  (
    await ropoloRequest.reportsOrderstatisticsperhourList(params, {
      paramsSerializer: {
        indexes: null,
      },
    })
  ).data;

const getHourlyMostSailedReports = async (params: HourlyReportMostSailedParams) =>
  (
    await ropoloRequest.reportsMostsailedperhourList(params, {
      paramsSerializer: {
        indexes: null,
      },
    })
  ).data;

const getHourlyMostSailedToppingReports = async (params: HourlyReportMostSailedParams) =>
  (
    await ropoloRequest.reportsMostsaileditemtoppingperhourList(params, {
      paramsSerializer: {
        indexes: null,
      },
    })
  ).data;

const downloadHourlyExcelReports = async (params: HourlyReportMostSailedParams) =>
  (
    await ropoloRequest.reportsMostsailedperhourExcelList(params, {
      paramsSerializer: {
        indexes: null,
      },
    })
  ).data;

const downloadDailyOrdersExcelReports = async (params: DailyReportParams) =>
  (
    await ropoloRequest.reportsOrderExcelList(params, {
      paramsSerializer: {
        indexes: null,
      },
    })
  ).data;

const cancelReportHourService = async (params: HourlyReportParams) =>
  (
    await ropoloRequest.reportsCancelledorderstatisticsperhourList(params, {
      paramsSerializer: {
        indexes: null,
      },
    })
  ).data;

const cancelReportDailyService = async (params: DailyReportParams) =>
  (
    await ropoloRequest.reportsCancelledorderstatisticsList(params, {
      paramsSerializer: {
        indexes: null,
      },
    })
  ).data;

const downloadCancelHourlyExcelReports = async (params: DailyReportParams) =>
  (
    await ropoloRequest.reportsCancelledorderExcelList(params, {
      paramsSerializer: {
        indexes: null,
      },
    })
  ).data;

const getDailySnappFoodReports = async (params: DailyReportParams) =>
  (
    await ropoloRequest.reportsSnappfoodorderstatisticsList(params, {
      paramsSerializer: {
        indexes: null,
      },
    })
  ).data;

const getDailySnappFoodHourlyReports = async (params: DailyReportParams) =>
  (
    await ropoloRequest.reportsSnappfoodorderstatisticsperhourList(params, {
      paramsSerializer: {
        indexes: null,
      },
    })
  ).data;

const getUnpaidOrdersReport = async (params: SummeryReportParams) =>
  (
    await ropoloRequest.reportsOrdersunpaidList(params, {
      paramsSerializer: {
        indexes: null,
      },
    })
  ).data;

const getPaidOrdersReport = async (params: SummeryReportParams) =>
  (
    await ropoloRequest.reportsOrderpaidList(params, {
      paramsSerializer: {
        indexes: null,
      },
    })
  ).data;

const getItemsSailedReports = async (params: ItemsReportParams) =>
  (
    await ropoloRequest.reportsMostsailedreportList(params, {
      paramsSerializer: {
        indexes: null,
      },
    })
  ).data;

const getItemsSailedReportsPerHour = async (params: ItemsReportParamsPerHour) =>
  (
    await ropoloRequest.reportsMostsailedperhourList(params, {
      paramsSerializer: {
        indexes: null,
      },
    })
  ).data;

const getProductsReport = async (params: ItemsReportParams) =>
  (
    await ropoloRequest.reportsProductsreportList(params, {
      paramsSerializer: {
        indexes: null,
      },
    })
  ).data;

const downcellExcelReports = async (params: MenuItemReportParams) =>
  (
    await ropoloRequest.reportsProductsreportExcelList(params, {
      paramsSerializer: {
        indexes: null,
      },
    })
  ).data;

const saleDetailsReport = async (params: SaleDetailsParams) =>
  (
    await ropoloRequest.reportsOrderstatisticsTypeList(params, {
      paramsSerializer: {
        indexes: null,
      },
    })
  ).data;

const creditSaleReport = async (params: CreditSaleParams) =>
  (
    await ropoloRequest.ordersGetcreditordersreportList(params, {
      paramsSerializer: {
        indexes: null,
      },
    })
  ).data;

const branchReport = async (params: BranchReportParams) =>
  (
    await ropoloRequest.ordersGetvendorbrandpaymentmethodsalesreportList(params, {
      paramsSerializer: {
        indexes: null,
      },
    })
  ).data;

const snappfoodReport = async (params: SnappfoodReportParams) =>
  (
    await ropoloRequest.reportsSnappfooddiscountreportList(params, {
      paramsSerializer: {
        indexes: null,
      },
    })
  ).data;

const snappfoodReportExcel = async (params: SnappfoodReportParams) =>
  (
    await ropoloRequest.reportsSnappfooddiscountreportExcelList(params, {
      paramsSerializer: {
        indexes: null,
      },
    })
  ).data;

const salePosDeviceReport = async (params: FilterPosParams) =>
  (
    await ropoloRequest.transactionsPostransactionreportList(
      {
        FromDate: params.from,
        ToDate: params?.to,
        Search: params?.search,
        OrderType: params?.orderType,
        vendorIds: params?.vendorIds,
      },
      {
        paramsSerializer: {
          indexes: null,
        },
      }
    )
  ).data;

const salePosDeviceExcelReport = async (params: FilterPosParams) =>
  (
    await ropoloRequest.transactionsPostransactionreportExcelList(
      {
        FromDate: params.from,
        ToDate: params?.to,
        Search: params?.search,
        OrderType: params?.orderType,
        vendorIds: params?.vendorIds,
      },
      {
        paramsSerializer: {
          indexes: null,
        },
      }
    )
  ).data;

const branchExcelReport = async (params: BranchReportParams) =>
  (
    await ropoloRequest.ordersGetvendorbrandpaymentmethodsalesreportExcelList(params, {
      paramsSerializer: {
        indexes: null,
      },
    })
  ).data;

const saleDetailsExcelReport = async (params: OrderstatisticsExcelParams) =>
  (
    await ropoloRequest.reportsOrderstatisticsExcelList(params, {
      paramsSerializer: {
        indexes: null,
      },
    })
  ).data;

const tableReport = async (params: ItemsTableReport) =>
  (
    await ropoloRequest.reportsGetdiningtableordersreportList(params, {
      paramsSerializer: {
        indexes: null,
      },
    })
  ).data;

const orderHistoryReport = async (id: string) => (await ropoloRequest.reportsOrderhistoryDetail(id)).data;

const getOrderItemsSalesReport = async (params: OrderItemsSalesParams) =>
  (
    await ropoloRequest.reportsGetorderitemssalesreportExcelList(params, {
      paramsSerializer: {
        indexes: null,
      },
    })
  ).data;

const getOrderItemsPrinterStationSalesReport = async (params: OrderItemsSalesParams) =>
  (await ropoloRequest.reportsGetorderitemsprinterstationsalesreportExcelList(params)).data;

const getOrderItemsDeliveryReport = async (params: OrderItemsDeliveryReportExcelParams) =>
  (
    await ropoloRequest.reportsGetorderitemsdeliveryreportExcelList(params, {
      paramsSerializer: {
        indexes: null,
      },
    })
  ).data;

export {
  cancelReportDailyService,
  cancelReportHourService,
  downcellExcelReports,
  downloadCancelHourlyExcelReports,
  downloadDailyExcelReports,
  downloadDailyOrdersExcelReports,
  downloadHourlyExcelReports,
  getDailyInfoReports,
  getDailyMostSailedReports,
  getDailyMostToppingSailedReports,
  getDailySnappFoodHourlyReports,
  getDailySnappFoodReports,
  getHourlyInfoReportsFromToService,
  getHourlyInfoReportsService,
  getHourlyMostSailedReports,
  getHourlyMostSailedToppingReports,
  getItemsSailedReports,
  getItemsSailedReportsPerHour,
  getOrderItemsDeliveryReport,
  getOrderItemsPrinterStationSalesReport,
  getOrderItemsSalesReport,
  getPaidOrdersReport,
  getProductsReport,
  getUnpaidOrdersReport,
  orderHistoryReport,
  saleDetailsExcelReport,
  saleDetailsReport,
  salePosDeviceReport,
  tableReport,
  salePosDeviceExcelReport,
  creditSaleReport,
  branchReport,
  branchExcelReport,
  snappfoodReport,
  snappfoodReportExcel,
};
